var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9C19 12.866 15.866 16 12 16C8.13401 16 5 12.866 5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9ZM13.2068 7.33167L12.319 5.21798C12.197 4.92734 11.803 4.92734 11.681 5.21798L10.7932 7.33167C10.7426 7.45209 10.634 7.53468 10.5089 7.54782L8.31415 7.77848C8.01236 7.81019 7.89063 8.20235 8.11697 8.41369L9.76308 9.95068C9.85686 10.0382 9.89835 10.1719 9.87165 10.3004L9.40299 12.5567C9.33854 12.8669 9.65723 13.1093 9.91919 12.9492L11.8243 11.7855C11.9329 11.7192 12.0671 11.7192 12.1757 11.7855L14.0808 12.9492C14.3428 13.1093 14.6615 12.8669 14.597 12.5567L14.1284 10.3004C14.1017 10.1719 14.1431 10.0382 14.2369 9.95068L15.883 8.41369C16.1094 8.20235 15.9876 7.81019 15.6859 7.77848L13.4911 7.54782C13.366 7.53468 13.2574 7.45209 13.2068 7.33167Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59992 13.1851L2.13252 17.5378C1.73138 18.2455 2.2956 19.1159 3.09212 19.0181L5.26696 18.7513C5.69656 18.6985 6.10876 18.9409 6.27874 19.3462L7.13924 21.398C7.45439 22.1494 8.47657 22.2119 8.87771 21.5043L11.1702 17.4601C8.34891 17.1868 5.93128 15.5342 4.59992 13.1851Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8298 17.4601L15.1223 21.5043C15.5234 22.2119 16.5456 22.1494 16.8608 21.398L17.7213 19.3462C17.8912 18.9409 18.3034 18.6985 18.733 18.7513L20.9079 19.0181C21.7044 19.1159 22.2686 18.2455 21.8675 17.5378L19.4001 13.1851C18.0687 15.5342 15.6511 17.1868 12.8298 17.4601Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge9);
export default __webpack_public_path__ + "static/media/badge-9.c1aee503b5c62c71f86eb850f649ce8b.svg";
export { ForwardRef as ReactComponent };